import React from 'react'
import { WallboxConfigurationModel } from 'src/Libs/wallboxes'
import SettingsFormContainer from 'src/Elements/SystemSettings/forms/SettingsFormContainer'
import { AuthFieldSet, CommonFieldSet, HysteresisFieldSet, NetworkFieldSet } from 'src/Libs/wallboxes/components/settings/tiles'
import { Grid } from '@mui/material'
import WallboxSettingsFormGridItem from './WallboxSettingsFormGridItem'
import WallboxSettingsFormGridContainer from './WallboxSettingsFormGridContainer'

interface Props {
  model: WallboxConfigurationModel
  hasWritingAccess: boolean
}

/**
 * Configured form component for a Wallbox of type EasyConnect (@see https://docs.e3dc.com/x/zgrIAw)
 */
const WallboxSettingsEasyConnectForm: React.FC<Props> = ({ model, hasWritingAccess }) => {
  return (
    <SettingsFormContainer model={model}>
      <WallboxSettingsFormGridContainer>
        <WallboxSettingsFormGridItem>
          <CommonFieldSet model={model} disabled={!hasWritingAccess} />
        </WallboxSettingsFormGridItem>

        <WallboxSettingsFormGridItem>
          <HysteresisFieldSet model={model} disabled={!hasWritingAccess} />
        </WallboxSettingsFormGridItem>
        <Grid item xs={12}>
          <AuthFieldSet model={model} disabled={!hasWritingAccess} />
        </Grid>
        <Grid item xs={12}>
          <NetworkFieldSet model={model} disabled={!hasWritingAccess} />
        </Grid>
      </WallboxSettingsFormGridContainer>
    </SettingsFormContainer>
  )
}

export default WallboxSettingsEasyConnectForm
